export const TYPICAL_RESPONSE_TIME = 'TYPICAL_RESPONSE_TIME';